// extracted by mini-css-extract-plugin
export default {"modalTitle":"CopyLinkPopup_modalTitle__b7yUQ","closeModalButton":"CopyLinkPopup_closeModalButton__DYOgj","buttonSection":"CopyLinkPopup_buttonSection__106zb"};